import React from 'react';
import { useNavigate } from 'react-router-dom';
import { handleLogout } from '../services/authService';
import Menu from './Menu';
import './NavBar.css';
import { initialiseAccessButton } from '@workspace/access-button-launcher';
import { useSelector } from 'react-redux';
import { BUTTON_TOKEN_API_URL, BASE_API_URL } from '../config/constants';

const NavBar = ({ loggedIn }) => {
    const navigate = useNavigate();

    const { idToken } = useSelector((state) => state.auth);

    const getButtonToken = () => {
        const body = new URLSearchParams({
            idToken: idToken,
        });

        return fetch(`${BUTTON_TOKEN_API_URL}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
            },
            body: body.toString(),
        });
    };

    const onAuthButtonClick = () => {
        if (loggedIn) {
            handleLogout();
        } else {
            navigate('/login');
        }
    };

    if (window.location === window.parent.location) {
        initialiseAccessButton({
            environment: 'preprod',
            view: 'desktop',
            closedZindex: 1000,
            positions: {
                desktop: {
                    top: 12,
                    left: 120,
                },
            },
            getToken: () => getButtonToken(),
            menuEndpoint: `${BASE_API_URL}api/button/menu`,
        }).then(accessButtonInstance => {
            console.log('Access Button initialized');
        }).catch(error => {
            console.error('Failed to initialize Access Button:', error);
        });
    }

    return (
        <nav className="navBar">
            <div className="navContainer">
                <div className="navSectionLeft">
                    <Menu /> 
                </div>
                <div className="navSectionCenter">
                    <span className="navTitle">My App</span>
                </div>
                { window.location === window.parent.location && (
                      <div className="navSectionRight">
                    <button className="navButton" onClick={onAuthButtonClick}>
                        {loggedIn ? 'Log out' : 'Log in'}
                    </button>
                </div>
                )}
              
            </div>
        </nav>
    );
};

export default NavBar;
